import React, { Fragment } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { OfferPush } from 'Components/widgets/offers-push/OfferPush';
import { Slider } from 'Components/frameworks/slider/Slider';
import { OFFER_STYLE, RATIO_DISPLAYS } from './image.constants';
const TRACKING = {
  actionGA: 'push_content_offers',
  labelGA: 'seeMore',
};
export const OffersPushLineLarge = ({
  title,
  seeMoreLabel,
  seeMoreLink,
  columns,
}: CMSOffersPush) => {
  // use isDesktop to display slider's controls only on desktops
  const { isDesktop } = useResponsive();
  const track = useTracking(TRACKING);
  return (
    <Fragment>
      <div className="flex flex-wrap justify-between">
        {title && <LineTitle className="flex-1 md:flex-none">{title}</LineTitle>}
        {seeMoreLabel && seeMoreLink && (
          <DynamicLink
            className="mx-0 mt-5 text-14 text-black underline hocus:text-black-active"
            onClick={() => track()}
            url={seeMoreLink}
          >
            {seeMoreLabel}
          </DynamicLink>
        )}
      </div>
      <Slider
        className="-mx-20 w-screen lg:mx-0 lg:w-full"
        cols={0}
        hasControls={isDesktop}
        navPosition="center"
        nbItemsToScroll={2}
        nextLabel={t('common.next')}
        previousLabel={t('common.previous')}
        scrollAreaContainerClassName="gap-20 px-20 lg:px-0 scrollbar-hidden scroll-x scroll-smooth"
        scrollControlsClassName="-mx-20 lg:mx-0"
      >
        {columns.map((column, index) => (
          <div className={OFFER_STYLE} key={index}>
            <OfferPush {...column} id={index + 1} ratioDisplay={RATIO_DISPLAYS} />
          </div>
        ))}
      </Slider>
    </Fragment>
  );
};
